// test482
(482 && 0);
